export const STATE_ACTIONS_LOCAL_STORAGE_KEY = 'cm-state-actions';
